// extracted by css-extract-rspack-plugin
export default {"row":"Controls-module__row___CZ5yQ","triplet":"Controls-module__triplet___TD265","select":"Controls-module__select___BRNgk","selectWide":"Controls-module__selectWide___mTTum"};